import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-stat-tile',
  imports: [DecimalPipe],
  host: { class: 'stat-tile' },
  template: `
    <div class="stat-label">{{ label() }}</div>
    <div class="stat-value">{{ value() | number }}</div>
    @if (hint()) {
      <div class="stat-hint">{{ hint() }}</div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatTile {
  readonly label = input.required<string>();
  readonly value = input.required<number>();
  readonly hint = input('');
}
